<script>
  import { onMount } from 'svelte'
  import { writable, derived } from 'svelte/store'
  
  import DonutRenderer from './DonutRenderer.svelte'
  import IntersectionObserver from '../util/IntersectionObserver.svelte'

  export let dataUrl = 'https://webcentral.uc.edu/scorecard/facultyraceJson.cfm'
  export let sortLegendByValues = false
  /**
   * @type {string}
   * This must be set when the graph is placed/implemented
   */
  export let allyDescription = ''

  const apiData = writable([])

  const massagedData = derived(apiData, ($apiData) => {
    if ($apiData){
      let data = []
      for (const [key, value] of Object.entries($apiData)) {
        // console.log(`${key}: ${value}`)
        data.push({name: String(key), y: Number(value)})
      }

      // alphabetize the new data array by name, unless we tell it to use the number
      if(sortLegendByValues) {
        data.sort((a, b)=>{
          if(a.y > b.y) { 
            return -1
          } else if(a.y < b.y) { 
            return 1
          } else {
            return 0
          }
        })
      } else {
        data.sort((a, b)=>{
          if(a.name < b.name) { 
            return -1
          } else if(a.name > b.name) { 
            return 1
          } else {
            return 0
          }
        })
      }

      return data
    }
  
  return []
})

  onMount(async () => {
    fetch(dataUrl)
    .then(response => response.json())
    .then(data => {
      apiData.set(data)
    }).catch(error => {
      console.error(error)
      return []
    })
  })
</script>

<IntersectionObserver class="" let:intersecting once={true} bottom={ 500 }>
  { #if intersecting }
    <DonutRenderer data={ $massagedData } { allyDescription } />
  { :else }
    <div style="min-height: 500px"></div>
  { /if }
</IntersectionObserver>